import { render, staticRenderFns } from "./upcoming_orders.vue?vue&type=template&id=060c6636&scoped=true&"
import script from "./upcoming_orders.vue?vue&type=script&lang=js&"
export * from "./upcoming_orders.vue?vue&type=script&lang=js&"
import style0 from "./upcoming_orders.vue?vue&type=style&index=0&id=060c6636&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c6636",
  null
  
)

export default component.exports